import {
  SET_TIKTOKSHOP_UI_FLAG,
  GET_COUPONS,
  GET_ORDERS,
  SEARCH_PRODUCTS,
  SEND_PRODUCT_MESSAGE,
  SEND_ORDER_MESSAGE,
} from './types';

export const mutations = {
  [SET_TIKTOKSHOP_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [GET_COUPONS]($state, data) {
    $state.coupons = data;
  },
  [GET_ORDERS]($state, data) {
    $state.orders = data;
  },
  [SEARCH_PRODUCTS]($state, data) {
    $state.products = data;
  },
  [SEND_PRODUCT_MESSAGE]: $state => {
    $state.records = {};
  },
  [SEND_ORDER_MESSAGE]: $state => {
    $state.records = {};
  },
};
